module.exports = __webpack_public_path__ + "img/bgr-home.42a03a50.png";